/*@flow*/
import * as I from 'immutable';
import type { StateT } from './types';
import mkDistrict from './mkDistrict';

const initState = {
  mode: 'READY',
  serverErrors: [],
  areaBackup: mkDistrict(),
  areaWorkingCopy: mkDistrict(),
  showEditOverlay: false,
  initCompState: {},
};

const fn: I.RecordFactory<StateT> = I.Record(initState, 'State');

export default fn;
